namespace GeniuzPOS.InitialData {
    export interface PsShopForm {
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        ShopNameEN: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        BranchNameEN: Serenity.StringEditor;
        ShopAddress: Serenity.StringEditor;
        ShopAddressEN: Serenity.StringEditor;
        ShopTypeId: Serenity.LookupEditor;
        ShopGroupId: Serenity.LookupEditor;
        ShopRegName: Serenity.StringEditor;
        ShopRegAddressLine1: Serenity.StringEditor;
        ShopRegAddressLine2: Serenity.StringEditor;
        ShopRegAddressLine3: Serenity.StringEditor;
        ShopTaxId: Serenity.StringEditor;
        ShopRegId: Serenity.StringEditor;
        PromptPayLink: Serenity.StringEditor;
        QRCodeAccount: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        TelId: Serenity.StringEditor;
        BranchTaxCode: Serenity.StringEditor;
        BranchNameDesc: Serenity.StringEditor;
        BranchNameDescEn: Serenity.StringEditor;
        ShopBuildingNo: Serenity.StringEditor;
        ShopBuildingNoEn: Serenity.StringEditor;
        ShopBuildingName: Serenity.StringEditor;
        ShopBuildingNameEn: Serenity.StringEditor;
        ShopStreetName: Serenity.StringEditor;
        ShopStreetNameEn: Serenity.StringEditor;
        ShopDistrict: Serenity.StringEditor;
        ShopDistrictEn: Serenity.StringEditor;
        ShopCity: Serenity.StringEditor;
        ShopCityEn: Serenity.StringEditor;
        ShopProvince: Serenity.StringEditor;
        ShopProvinceEn: Serenity.StringEditor;
        ShopPostalCode: Serenity.StringEditor;
        ShopCountryCode: Serenity.StringEditor;
        ErpStore: Serenity.StringEditor;
        ErpChannel: Serenity.StringEditor;
    }

    export class PsShopForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsShop';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsShopForm.init)  {
                PsShopForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(PsShopForm, [
                    'ShopId', w0,
                    'ShopName', w0,
                    'ShopNameEN', w0,
                    'BranchName', w0,
                    'BranchNameEN', w0,
                    'ShopAddress', w0,
                    'ShopAddressEN', w0,
                    'ShopTypeId', w1,
                    'ShopGroupId', w1,
                    'ShopRegName', w0,
                    'ShopRegAddressLine1', w0,
                    'ShopRegAddressLine2', w0,
                    'ShopRegAddressLine3', w0,
                    'ShopTaxId', w0,
                    'ShopRegId', w0,
                    'PromptPayLink', w0,
                    'QRCodeAccount', w0,
                    'Email', w0,
                    'TelId', w0,
                    'BranchTaxCode', w0,
                    'BranchNameDesc', w0,
                    'BranchNameDescEn', w0,
                    'ShopBuildingNo', w0,
                    'ShopBuildingNoEn', w0,
                    'ShopBuildingName', w0,
                    'ShopBuildingNameEn', w0,
                    'ShopStreetName', w0,
                    'ShopStreetNameEn', w0,
                    'ShopDistrict', w0,
                    'ShopDistrictEn', w0,
                    'ShopCity', w0,
                    'ShopCityEn', w0,
                    'ShopProvince', w0,
                    'ShopProvinceEn', w0,
                    'ShopPostalCode', w0,
                    'ShopCountryCode', w0,
                    'ErpStore', w0,
                    'ErpChannel', w0
                ]);
            }
        }
    }
}
